import React, { useEffect, useState } from "react";
import { Phone, Menu as MenuIcon, X } from "lucide-react";
import { RESTAURANT } from "../mock";

const LINKS = [
  { label: "Menu", href: "#menu" },
  { label: "Cakes", href: "#cakes" },
  { label: "Story", href: "#story" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#141110]/95 backdrop-blur-md shadow-[0_2px_18px_-6px_rgba(0,0,0,0.6)] py-2"
          : "bg-gradient-to-b from-[#141110]/85 to-transparent py-3"
      }`}
      style={{
        paddingTop: `calc(${scrolled ? "0.5rem" : "0.75rem"} + env(safe-area-inset-top))`,
      }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a href="#top" className="flex items-center group">
          <img
            src={`${process.env.PUBLIC_URL || ""}/logo.png`}
            alt="Uncle Willie's Southern Bistro"
            className="h-12 md:h-14 w-auto transition-transform duration-300 group-hover:scale-105"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline font-mono text-[13px] uppercase tracking-widest text-[#F3EAD7]/90 hover:text-[#F0C766]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={RESTAURANT.phoneHref}
          className="hidden md:flex btn-primary items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold"
        >
          <Phone size={15} /> Call &amp; Order
        </a>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#F3EAD7]"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <MenuIcon size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#141110] border-t border-[#2E2823] mt-2">
          <div className="px-6 py-5 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-mono text-sm uppercase tracking-widest text-[#F3EAD7]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={RESTAURANT.phoneHref}
              className="btn-primary flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold mt-2"
            >
              <Phone size={15} /> {RESTAURANT.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
